"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (limit) => {
    const { count, interval } = limit;
    if (!interval) {
        return 'Once';
    }
    const { unit, value } = interval;
    const countCopy = getCountCopy(count);
    const unitCopy = getUnitCopy(unit, value);
    const valueCopy = getValueCopy(value);
    return `${countCopy} per ${valueCopy}${unitCopy}`;
};
const getCountCopy = (count) => {
    switch (count) {
        case 1:
            return 'Once';
        default:
            return `${count} times`;
    }
};
const getUnitCopy = (unit, value) => {
    const isPlural = value > 1;
    switch (unit) {
        case 's':
            return `second${isPlural ? 's' : ''}`;
        case 'm':
            return `minute${isPlural ? 's' : ''}`;
        case 'h':
            return `hour${isPlural ? 's' : ''}`;
        case 'd':
            return `day${isPlural ? 's' : ''}`;
        default:
            return '';
    }
};
const getValueCopy = (value) => (value > 1 ? `${value} ` : '');
